import {
  addDays,
  addWeeks,
  getDay,
  startOfDay,
  subDays,
  subWeeks,
} from "date-fns";
import { create } from "zustand";

export function toNearestWeekday(date: Date): Date {
  const day = getDay(date);
  if (day === 0) {
    return subDays(date, 2);
  }
  if (day === 6) {
    return subDays(date, 1);
  }
  return date;
}

interface DateState {
  selectedDate: Date;
  setSelectedDate: (date: Date) => void;
  goToToday: () => void;
  goToPreviousDay: () => void;
  goToNextDay: () => void;
  goToPreviousWeek: () => void;
  goToNextWeek: () => void;
}

export const useDateStore = create<DateState>()((set) => ({
  selectedDate: startOfDay(new Date()),

  setSelectedDate: (date) => set({ selectedDate: startOfDay(date) }),

  goToToday: () => set({ selectedDate: startOfDay(new Date()) }),

  goToPreviousDay: () =>
    set((state) => ({ selectedDate: subDays(state.selectedDate, 1) })),

  goToNextDay: () =>
    set((state) => ({ selectedDate: addDays(state.selectedDate, 1) })),

  goToPreviousWeek: () =>
    set((state) => ({ selectedDate: subWeeks(state.selectedDate, 1) })),

  goToNextWeek: () =>
    set((state) => ({ selectedDate: addWeeks(state.selectedDate, 1) })),
}));
